const ARCHIVED_COUNT_UNAVAILABLE_KEY = 'hiromatch:archived-count-unavailable';

export function isArchivedCountEndpointUnavailable(companyId: string): boolean {
  try {
    return sessionStorage.getItem(`${ARCHIVED_COUNT_UNAVAILABLE_KEY}:${companyId}`) === '1';
  } catch {
    return false;
  }
}

export function markArchivedCountEndpointUnavailable(companyId: string): void {
  try {
    sessionStorage.setItem(`${ARCHIVED_COUNT_UNAVAILABLE_KEY}:${companyId}`, '1');
  } catch {
    // private mode / quota
  }
}

export function clearArchivedCountEndpointUnavailable(companyId: string): void {
  try {
    sessionStorage.removeItem(`${ARCHIVED_COUNT_UNAVAILABLE_KEY}:${companyId}`);
  } catch {
    // ignore
  }
}
